<div class="ziti-page-container ziti-edge-routers-container">
  <lib-list-page-header [title]="title"
    [tabs]="tabs"
    [showAdd]="!itemsSelected"
    [blockCreate]="headerBlockCreate"
    [blockDelete]="headerBlockDelete"
  (actionClicked)="headerActionClicked($event)"></lib-list-page-header>

  <lib-data-table [tableId]="'edge-routers'"
    [noItemsReadonly]="headerBlockCreate"
    [accessDenied]="headerBlockRead"
    [rowData]="rowData"
    [isLoading]="isLoading"
    [columnDefinitions]="columnDefs"
    (actionRequested)="tableAction($event)"
    [startCount]="startCount"
    [endCount]="endCount"
    [totalCount]="totalCount"
    [emptyMsg]="'No Edge Routers defined, Click the plus to add an Edge Router.'"
    [filterApplied]="filterApplied"
    [menuItems]="svc.menuItems"
    [headerActions]="svc.tableHeaderActions"
    [noItemsImage]="'No_Routers'"
    >
  </lib-data-table>
</div>
@if (isLoading) {
  <lib-loading-indicator [isLoading]="isLoading"></lib-loading-indicator>
}
